import { useState, useRef, useEffect } from 'react'

/**
 * FilterBar — hidden filters revealed on demand
 *
 * Usage:
 * <FilterBar
 *   filters={[{ key: 'all', label: 'All' }, { key: 'reading', label: 'Reading' }]}
 *   active={activeFilter}
 *   onChange={setActiveFilter}
 * />
 */
export default function FilterBar({ filters = [], active, onChange, className = '' }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  const activeLabel = filters.find(f => f.key === active)?.label || 'All'

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    const handleKey = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleKey)
    }
  }, [])

  return (
    <div className={`filter-bar ${className}`} ref={ref}>
      <button
        className={`filter-bar__trigger ${active && active !== 'all' ? 'filter-bar__trigger--active' : ''}`}
        onClick={() => setOpen(o => !o)}
        type="button"
      >
        <span>⊞ Filter</span>
        {active && active !== 'all' && (
          <span className="filter-bar__active-label">{activeLabel}</span>
        )}
        <span className="filter-bar__chevron">{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div className="filter-bar__dropdown">
          {filters.map(f => (
            <button
              key={f.key}
              className={`filter-bar__option ${f.key === active ? 'filter-bar__option--active' : ''}`}
              onClick={() => { onChange(f.key); setOpen(false) }}
              type="button"
            >
              {f.icon && <span>{f.icon}</span>}
              {f.label}
              {f.key === active && <span className="filter-bar__check">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
